import * as z from 'zod';

import { inventoryQuerySchema } from '../inventory';

export const inventoryKitItemQuerySchema = z.object({
  id: z.number(),
  inventory_id: z.number(),
  inventory: inventoryQuerySchema.nullish(),
  inventory_kit_id: z.number(),
  quantity: z.number(),
  sort_order: z.number(),
});

export type InventoryKitItemQuerySchema = z.infer<typeof inventoryKitItemQuerySchema>;
